// Exterior Samples 1
// Coastal
import coastal01jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/01.jpeg';
import coastal02jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/02.jpeg';
import coastal03jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/03.jpeg';
import coastal04jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/04.jpeg';
import coastal05jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/05.jpeg';
import coastal06jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/06.jpeg';
import coastal07jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/07.jpeg';
import coastal08jpeg from 'assets/img/homeownerApp/samples/exterior/Coastal/08.jpeg';
// Contemporary
import contemporary01jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/01.jpeg';
import contemporary02jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/02.jpeg';
import contemporary03jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/03.jpeg';
import contemporary04jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/04.jpeg';
import contemporary05jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/05.jpeg';
import contemporary06jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/06.jpeg';
import contemporary07jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/07.jpeg';
import contemporary08jpeg from 'assets/img/homeownerApp/samples/exterior/Contemporary/08.jpeg';
// Cottage
import cottage01jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/01.jpeg';
import cottage02jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/02.jpeg';
import cottage03jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/03.jpeg';
import cottage04jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/04.jpeg';
import cottage05jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/05.jpeg';
import cottage06jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/06.jpeg';
import cottage07jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/07.jpeg';
import cottage08jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/08.jpeg';
import cottage09jpeg from 'assets/img/homeownerApp/samples/exterior/Cottage/09.jpeg';
// Craftsman
import craftsman01jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/01.jpeg';
import craftsman02jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/02.jpeg';
import craftsman03jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/03.jpeg';
import craftsman04jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/04.jpeg';
import craftsman05jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/05.jpeg';
import craftsman06jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/06.jpeg';
import craftsman07jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/07.jpeg';
import craftsman08jpeg from 'assets/img/homeownerApp/samples/exterior/Craftsman/08.jpeg';
// Farmhouse
import farmhouse01jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/01.jpeg';
import farmhouse02jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/02.jpeg';
import farmhouse03jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/03.jpeg';
import farmhouse04jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/04.jpeg';
import farmhouse05jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/05.jpeg';
import farmhouse06jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/06.jpeg';
import farmhouse07jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/07.jpeg';
import farmhouse08jpeg from 'assets/img/homeownerApp/samples/exterior/Farmhouse/08.jpeg';
// Mediterranean
import mediterranean01jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/01.jpeg';
import mediterranean02jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/02.jpeg';
import mediterranean03jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/03.jpeg';
import mediterranean04jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/04.jpeg';
import mediterranean05jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/05.jpeg';
import mediterranean06jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/06.jpeg';
import mediterranean07jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/07.jpeg';
import mediterranean08jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/08.jpeg';
import mediterranean09jpeg from 'assets/img/homeownerApp/samples/exterior/Mediterranean/09.jpeg';
// Mid Century Modern
import midCenturyMod01jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/01.jpeg';
import midCenturyMod02jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/02.jpeg';
import midCenturyMod03jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/03.jpeg';
import midCenturyMod04jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/04.jpeg';
import midCenturyMod05jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/05.jpeg';
import midCenturyMod06jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/06.jpeg';
import midCenturyMod07jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/07.jpeg';
import midCenturyMod08jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/08.jpeg';
import midCenturyMod09jpeg from 'assets/img/homeownerApp/samples/exterior/MidCenturyModern/09.jpeg';
// Monochrome
import monochrome01jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/01.jpeg';
import monochrome02jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/02.jpeg';
import monochrome03jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/03.jpeg';
import monochrome04jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/04.jpeg';
import monochrome05jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/05.jpeg';
import monochrome06jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/06.jpeg';
import monochrome07jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/07.jpeg';
import monochrome08jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/08.jpeg';
import monochrome09jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/09.jpeg';
import monochrome10jpeg from 'assets/img/homeownerApp/samples/exterior/Monochrome/10.jpeg';
// Rustic
import rustic01jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/01.jpeg';
import rustic02jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/02.jpeg';
import rustic03jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/03.jpeg';
import rustic04jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/04.jpeg';
import rustic05jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/05.jpeg';
import rustic06jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/06.jpeg';
import rustic07jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/07.jpeg';
import rustic08jpeg from 'assets/img/homeownerApp/samples/exterior/Rustic/08.jpeg';
// Traditional
import traditional01jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/01.jpeg';
import traditional02jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/02.jpeg';
import traditional03jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/03.jpeg';
import traditional04jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/04.jpeg';
import traditional05jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/05.jpeg';
import traditional06jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/06.jpeg';
import traditional07jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/07.jpeg';
import traditional08jpeg from 'assets/img/homeownerApp/samples/exterior/Traditional/08.jpeg';

import type { ISamplePath } from './sampleImages';

/* eslint-disable prettier/prettier */

export const exteriorSamples: ISamplePath[] = [
  // Coastal
  { style: 'Coastal', jpeg: coastal01jpeg },
  { style: 'Coastal', jpeg: coastal02jpeg },
  { style: 'Coastal', jpeg: coastal03jpeg },
  { style: 'Coastal', jpeg: coastal04jpeg },
  { style: 'Coastal', jpeg: coastal05jpeg },
  { style: 'Coastal', jpeg: coastal06jpeg },
  { style: 'Coastal', jpeg: coastal07jpeg },
  { style: 'Coastal', jpeg: coastal08jpeg },
  // Contemporary
  { style: 'Contemporary', jpeg: contemporary01jpeg },
  { style: 'Contemporary', jpeg: contemporary02jpeg },
  { style: 'Contemporary', jpeg: contemporary03jpeg },
  { style: 'Contemporary', jpeg: contemporary04jpeg },
  { style: 'Contemporary', jpeg: contemporary05jpeg },
  { style: 'Contemporary', jpeg: contemporary06jpeg },
  { style: 'Contemporary', jpeg: contemporary07jpeg },
  { style: 'Contemporary', jpeg: contemporary08jpeg },
  // Cottage
  { style: 'Cottage', jpeg: cottage01jpeg },
  { style: 'Cottage', jpeg: cottage02jpeg },
  { style: 'Cottage', jpeg: cottage03jpeg },
  { style: 'Cottage', jpeg: cottage04jpeg },
  { style: 'Cottage', jpeg: cottage05jpeg },
  { style: 'Cottage', jpeg: cottage06jpeg },
  { style: 'Cottage', jpeg: cottage07jpeg },
  { style: 'Cottage', jpeg: cottage08jpeg },
  { style: 'Cottage', jpeg: cottage09jpeg },
  // Craftsman
  { style: 'Craftsman', jpeg: craftsman01jpeg },
  { style: 'Craftsman', jpeg: craftsman02jpeg },
  { style: 'Craftsman', jpeg: craftsman03jpeg },
  { style: 'Craftsman', jpeg: craftsman04jpeg },
  { style: 'Craftsman', jpeg: craftsman05jpeg },
  { style: 'Craftsman', jpeg: craftsman06jpeg },
  { style: 'Craftsman', jpeg: craftsman07jpeg },
  { style: 'Craftsman', jpeg: craftsman08jpeg },
  // Farmhouse
  { style: 'Farmhouse', jpeg: farmhouse01jpeg },
  { style: 'Farmhouse', jpeg: farmhouse02jpeg },
  { style: 'Farmhouse', jpeg: farmhouse03jpeg },
  { style: 'Farmhouse', jpeg: farmhouse04jpeg },
  { style: 'Farmhouse', jpeg: farmhouse05jpeg },
  { style: 'Farmhouse', jpeg: farmhouse06jpeg },
  { style: 'Farmhouse', jpeg: farmhouse07jpeg },
  { style: 'Farmhouse', jpeg: farmhouse08jpeg },
  // Mediterranean
  { style: 'Mediterranean', jpeg: mediterranean01jpeg },
  { style: 'Mediterranean', jpeg: mediterranean02jpeg },
  { style: 'Mediterranean', jpeg: mediterranean03jpeg },
  { style: 'Mediterranean', jpeg: mediterranean04jpeg },
  { style: 'Mediterranean', jpeg: mediterranean05jpeg },
  { style: 'Mediterranean', jpeg: mediterranean06jpeg },
  { style: 'Mediterranean', jpeg: mediterranean07jpeg },
  { style: 'Mediterranean', jpeg: mediterranean08jpeg },
  { style: 'Mediterranean', jpeg: mediterranean09jpeg },
  // Mid Century Modern
  { style: 'Mid-Century Modern', jpeg: midCenturyMod01jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod02jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod03jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod04jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod05jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod06jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod07jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod08jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyMod09jpeg },
  // Monochrome
  { style: 'Monochrome', jpeg: monochrome01jpeg },
  { style: 'Monochrome', jpeg: monochrome02jpeg },
  { style: 'Monochrome', jpeg: monochrome03jpeg },
  { style: 'Monochrome', jpeg: monochrome04jpeg },
  { style: 'Monochrome', jpeg: monochrome05jpeg },
  { style: 'Monochrome', jpeg: monochrome06jpeg },
  { style: 'Monochrome', jpeg: monochrome07jpeg },
  { style: 'Monochrome', jpeg: monochrome08jpeg },
  { style: 'Monochrome', jpeg: monochrome09jpeg },
  { style: 'Monochrome', jpeg: monochrome10jpeg },
  // Rustic
  { style: 'Rustic', jpeg: rustic01jpeg },
  { style: 'Rustic', jpeg: rustic02jpeg },
  { style: 'Rustic', jpeg: rustic03jpeg },
  { style: 'Rustic', jpeg: rustic04jpeg },
  { style: 'Rustic', jpeg: rustic05jpeg },
  { style: 'Rustic', jpeg: rustic06jpeg },
  { style: 'Rustic', jpeg: rustic07jpeg },
  { style: 'Rustic', jpeg: rustic08jpeg },
  // Traditional
  { style: 'Traditional', jpeg: traditional01jpeg },
  { style: 'Traditional', jpeg: traditional02jpeg },
  { style: 'Traditional', jpeg: traditional03jpeg },
  { style: 'Traditional', jpeg: traditional04jpeg },
  { style: 'Traditional', jpeg: traditional05jpeg },
  { style: 'Traditional', jpeg: traditional06jpeg },
  { style: 'Traditional', jpeg: traditional07jpeg },
  { style: 'Traditional', jpeg: traditional08jpeg },
];
